import React from "react";
import {
  FiMapPin,
  FiRefreshCw,
  FiRotateCw,
  FiSearch,
} from "react-icons/fi";

import Reveal from "../../../components/ui/Reveal";

import { POINT_TYPES } from "../data/carteInteretsUiData";
import { cn } from "../utils/carteInteretsUtils";
import TypeFilterChip from "./TypeFilterChip";

export default function CarteFilters({
  loading,
  filters,
  stats,
  onSearch,
  onToggleType,
  onReset,
  onRefresh,
}) {
  return (
    <Reveal>
      <section className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-950 sm:p-6">
        <div className="grid gap-5 lg:grid-cols-[1fr_auto] lg:items-end">
          <div className="space-y-2">
            <label
              htmlFor="poi-search"
              className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400"
            >
              <FiSearch className="h-4 w-4" />
              Recherche instantanée
            </label>

            <div className="relative">
              <FiSearch className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />

              <input
                id="poi-search"
                type="search"
                value={filters.q}
                onChange={(event) => onSearch(event.target.value)}
                placeholder="Nom, catégorie, adresse, téléphone, service…"
                className="h-12 w-full rounded-2xl border border-slate-200 bg-white pl-11 pr-4 text-sm font-semibold text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-[#1277B9] focus:ring-4 focus:ring-[#1277B9]/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white dark:placeholder:text-slate-500"
              />
            </div>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <button
              type="button"
              onClick={onReset}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:hover:bg-slate-900"
            >
              <FiRefreshCw className="h-4 w-4" />
              Réinitialiser
            </button>

            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:hover:bg-slate-900"
            >
              <FiRotateCw className={cn("h-4 w-4", loading && "animate-spin")} />
              Actualiser
            </button>
          </div>
        </div>

        <div className="mt-5 space-y-3">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
              <FiMapPin className="h-4 w-4" />
              Lieux visibles
            </p>

            <p className="text-xs font-semibold text-slate-500 dark:text-slate-400">
              {loading
                ? "Chargement…"
                : `${stats.filtered} lieu${stats.filtered > 1 ? "x" : ""} sur ${
                    stats.total
                  }`}
            </p>
          </div>

          <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1 md:flex-wrap md:overflow-visible">
            <TypeFilterChip
              active={filters.types.association}
              label={POINT_TYPES.association.label}
              color={POINT_TYPES.association.color}
              count={stats.association}
              onClick={() => onToggleType("association")}
            />

            <TypeFilterChip
              active={filters.types.commerce}
              label={POINT_TYPES.commerce.label}
              color={POINT_TYPES.commerce.color}
              count={stats.commerce}
              onClick={() => onToggleType("commerce")}
            />

            <TypeFilterChip
              active={filters.types.service}
              label={POINT_TYPES.service.label}
              color={POINT_TYPES.service.color}
              count={stats.service}
              onClick={() => onToggleType("service")}
            />
          </div>
        </div>
      </section>
    </Reveal>
  );
}